export const EmployeeActivityState = {
    WORK : 'WORK',
    BREAK : 'BREAK'
 };